import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';

import LoginForm from '../../sections/auth/LoginForm';

export default function LoginPage() {
  return (
    <Stack spacing={3}>
      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Typography variant="h4">Iniciar sesión</Typography>
        <Typography variant="body2" color="text.secondary">
          Accede con tu cuenta de cliente, administrador o técnico
        </Typography>
      </Stack>

      <LoginForm />

      <Typography variant="body2" sx={{ textAlign: 'center' }}>
        ¿No tienes una cuenta?{' '}
        <Link component={RouterLink} to="/registro">
          Regístrate
        </Link>
      </Typography>
    </Stack>
  );
}
